import type { TapActionType } from '../../lib/tapDocument';

// These symbols describe action categories; the action label remains the accessible name.
function TapActionIcon({ type }: { type: TapActionType }) {
  let symbol;
  switch (type) {
    case 'download-card':
      symbol = <><circle cx="12" cy="8" r="3" /><path d="M5 20v-1a7 7 0 0 1 14 0v1" /></>;
      break;
    case 'booking':
    case 'service-book':
      symbol = <><rect x="4" y="6" width="16" height="14" rx="2" /><path d="M8 3v6M16 3v6M4 11h16M8 15h2M14 15h2" /></>;
      break;
    case 'website':
      symbol = <><circle cx="12" cy="12" r="8" /><path d="M4 12h16M12 4c2.5 2.4 3.5 5.1 3.5 8s-1 5.6-3.5 8c-2.5-2.4-3.5-5.1-3.5-8s1-5.6 3.5-8Z" /></>;
      break;
    case 'social':
      symbol = <><circle cx="12" cy="7" r="3" /><circle cx="5.5" cy="17" r="2" /><circle cx="18.5" cy="17" r="2" /><path d="M10.5 9.5 7 15M13.5 9.5 17 15M7.5 17h9" /></>;
      break;
    case 'file':
      symbol = <><path d="M6 3h8l4 4v14H6zM14 3v5h4M12 11v6m-3-3 3 3 3-3" /></>;
      break;
    case 'custom':
      symbol = <><path d="M10 13.5 14 9.5M8.5 16.5l-1 1a3.5 3.5 0 0 1-5-5l3-3a3.5 3.5 0 0 1 5 0M15.5 7.5l1-1a3.5 3.5 0 0 1 5 5l-3 3a3.5 3.5 0 0 1-5 0" transform="translate(0 0)" /></>;
      break;
  }
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">{symbol}</svg>;
}

export { TapActionIcon };
